import { useEffect, useRef } from 'react';

const marqueeItems = [
  'Soins du Visage',
  'Massage Relaxant',
  'Manucure & Pédicure',
  'Beauté du Regard',
  'Coiffure Femme',
  'Soins du Corps',
  'Forfaits Bien-Être',
  'Carte Cadeau',
];

export default function MarqueeBanner() {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let pos = 0;
    let rafId: number;

    const animate = () => {
      pos -= 0.8;
      const max = el.scrollWidth / 2;
      if (Math.abs(pos) >= max) pos = 0;
      el.style.transform = `translateX(${pos}px)`;
      rafId = requestAnimationFrame(animate);
    };

    rafId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(rafId);
  }, []);

  const allItems = [...marqueeItems, ...marqueeItems, ...marqueeItems, ...marqueeItems];

  return (
    <section className="w-full py-4 bg-primary-500 overflow-hidden">
      <div
        ref={scrollRef}
        className="flex items-center gap-8 whitespace-nowrap will-change-transform"
      >
        {allItems.map((item, i) => (
          <div key={i} className="flex items-center gap-8 flex-shrink-0">
            <span className="text-background-50 text-sm md:text-base font-medium tracking-wide">
              {item}
            </span>
            <div className="w-2 h-2 rounded-full bg-background-50/40 flex-shrink-0" />
          </div>
        ))}
      </div>
    </section>
  );
}